import React from 'react';

import type { ClaimNotificationModel } from '../ClaimNotificationsCard/types';

interface ShowNotificationOnClickWrapperProps {
  onHandleShowNotification: (id: number) => Promise<void>;
  claimNotification: ClaimNotificationModel;
  children: React.ReactNode;
}
const ShowNotificationOnClickWrapper: React.FC<ShowNotificationOnClickWrapperProps> = ({
  onHandleShowNotification,
  claimNotification,
  children,
}) => (
  <div
    className="flex min-h-full min-w-full cursor-pointer items-center"
    onClick={async () => await onHandleShowNotification(claimNotification.id)}
  >
    {children}
  </div>
);

export default ShowNotificationOnClickWrapper;
